export const loginCredentialsResponse = 'loginCredentialsResponse';
export const _getParentQuestions = '_getParentQuestions';
export const _getQuestions = '_getQuestions';
export const _getSubmitReponse = '_getSubmitReponse';